var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeatures3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.25 5.96973H8.75C6.825 5.96973 5.25 7.54473 5.25 9.46973V33.9697C5.25 35.8947 6.825 37.4697 8.75 37.4697H33.25C35.175 37.4697 36.75 35.8947 36.75 33.9697V9.46973C36.75 7.54473 35.175 5.96973 33.25 5.96973ZM15.75 30.4697H12.25V18.2197H15.75V30.4697ZM22.75 30.4697H19.25V12.9697H22.75V30.4697ZM29.75 30.4697H26.25V23.4697H29.75V30.4697Z",
    fill: "#006EC2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatures3);
export default __webpack_public_path__ + "static/media/features3.6111a4319817b5b973bb58cbd16554b6.svg";
export { ForwardRef as ReactComponent };